import React from 'react';
import { BackLink } from './BackLink';
import NoMedications from '../Images/noMedications.svg';
import NoMedicationsAlt from '../Images/noMedicationsAlt.svg';
import styles from './NoMedicationsFound.module.css';
import classNames from 'classnames';
import { Button, ButtonVariant } from './Button';
export var NoMedicationsFound = function (props) {
    var _a;
    var containerClasses = classNames(styles.body, (_a = {},
        _a[styles.large] = props.largeMode,
        _a));
    return (React.createElement("div", { className: containerClasses },
        React.createElement("img", { src: props.useAlt ? NoMedicationsAlt : NoMedications, alt: '', className: styles.main }),
        React.createElement("div", { className: styles.title, style: { maxWidth: props.titleWidth } }, props.title),
        React.createElement("div", { className: styles.info, style: { maxWidth: props.infoWidth } }, props.info),
        React.createElement("div", { className: styles.actionButton },
            React.createElement(BackLink, { backLinkText: props.backLinkText, onClickBack: props.onClickBack }),
            props.showForwardButton && (React.createElement(Button, { className: styles.forwardButton, variant: ButtonVariant.primary, onClick: props.onClickForward, width: 168, testId: 'forward' }, props.forwardLinkText)))));
};
